import axios from 'axios';
import type { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getAuthToken, isClerkAuthEnabled } from 'src/utils/clerkAuth';

const NOTIFICATION_BASE_URL = `${import.meta.env.VITE_NOTIFICATION_URL}`;
const NOTIFICATION_API_VERSION = `${import.meta.env.VITE_NOTIFICATION_API_VERSION}`;
const NOTIFICATION_FE_API_KEY = import.meta.env.VITE_NOTIFICATION_API_KEY;

const axiosInstance = axios.create({
  baseURL: `${NOTIFICATION_BASE_URL}${NOTIFICATION_API_VERSION}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

/** Attach per-request authentication for Notification Center calls. */
export async function attachNotificationRequestHeaders(request: InternalAxiosRequestConfig) {
  request.headers = request.headers || {};

  if (isClerkAuthEnabled()) {
    const token = await getAuthToken();

    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    } else {
      delete request.headers.Authorization;
    }
  } else if (NOTIFICATION_FE_API_KEY) {
    request.headers.Authorization = NOTIFICATION_FE_API_KEY;
  } else {
    delete request.headers.Authorization;
  }
  return request;
}

axiosInstance.interceptors.request.use(attachNotificationRequestHeaders);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError<unknown>) => {
    throw error;
  },
);

/** Send a POST request to Notification Center. */
export const post = axiosInstance.post;
/** Send a PATCH request to Notification Center. */
export const patch = axiosInstance.patch;
/** Send a GET request to Notification Center. */
export const get = axiosInstance.get;
